module.exports = __webpack_public_path__ + "img/zw.80632a3c.svg";